import { render } from "./WorldMap.vue?vue&type=template&id=c82f80c4&scoped=true"
import script from "./WorldMap.vue?vue&type=script&lang=js"
export * from "./WorldMap.vue?vue&type=script&lang=js"

import "./WorldMap.vue?vue&type=style&index=0&id=c82f80c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c82f80c4"]])

export default __exports__